export default __webpack_public_path__ + "static/media/santaFeIcono.77cc2f61.jpg";